import { inject, type Provider, type Type } from '@angular/core';
import { FEATURE_FLAG, FeatureFlagService } from '@quipex/core/config';
import {
    QUIPPY_PACK_ACTIONS_ENABLED,
    QUIPPY_CHAT_HANDOFF,
    QUIPPY_CHAT_ENTRY,
    QUIPPY_HOME_ACTIONS,
    QUIPPY_HOST_ACTIONS,
    QUIPPY_SCOPE_PICKER_COMPONENT,
    provideQuippySession,
    type QuippyScopePickerAdapter,
} from '@quipex/feature/quippy-conversation';
import { QuippyChatEntryState } from './chat-entry/chat-entry';
import { QuippyScopeNavigation } from './chat-entry/scope-navigation';
import { AppQuippyHostActions } from './host-actions';

export interface AppQuippyRuntimeOptions {
    readonly scopePicker: Type<QuippyScopePickerAdapter>;
}

/** One Quippy session and host coordinator per authenticated app route tree. */
export function provideAppQuippyRuntime(
    options: AppQuippyRuntimeOptions
): Provider[] {
    return [
        ...provideQuippySession(),
        {
            provide: QUIPPY_PACK_ACTIONS_ENABLED,
            useFactory: () =>
                inject(FeatureFlagService).flagEnabled(
                    FEATURE_FLAG.QuippyPackActions
                ),
        },
        QuippyChatEntryState,
        { provide: QUIPPY_CHAT_ENTRY, useExisting: QuippyChatEntryState },
        { provide: QUIPPY_CHAT_HANDOFF, useExisting: QuippyChatEntryState },
        QuippyScopeNavigation,
        { provide: QUIPPY_HOME_ACTIONS, useExisting: QuippyScopeNavigation },
        AppQuippyHostActions,
        { provide: QUIPPY_HOST_ACTIONS, useExisting: AppQuippyHostActions },
        {
            provide: QUIPPY_SCOPE_PICKER_COMPONENT,
            useValue: options.scopePicker,
        },
    ];
}
